/**
 * @generated SignedSource<<72f60342e20276f4d0549db6e76f8515>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButtons_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_user" | "PdpSharedBuyItNowButton_user">;
  readonly " $fragmentType": "PdpSharedShoppingButtons_user";
};
export type PdpSharedShoppingButtons_user$key = {
  readonly " $data"?: PdpSharedShoppingButtons_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButtons_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButtons_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyItNowButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAddToCartButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "feb18302bae8e1fa4e0548cf850da7bc";

export default node;
